class PrimeProjectViewController {
  constructor() {
    'ngInject';
  }
}

export default PrimeProjectViewController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/prime-project-view/prime-project-view.controller.js